import { QUIZ_VARIANTS } from '@/modules/tour/domain/tour';
import { getBaseDomain } from '@/services/url';

export const baseUrls = {
  terms: {
    defaultUrl: '/terms',
    specialUrl: '/terms-us',
    compliantOthers: '/terms',
  },
  privacy: {
    defaultUrl: '/privacy',
    specialUrl: '/privacy-us',
    europeAndUkUrl: '/privacy-eu',
    compliantOthers: '/privacy-eu',
  },
};

export const getBaseUrl = (type, quizVariant) => {
  const variantMap = {
    [QUIZ_VARIANTS.PILATES_NEW_CHECKOUT]: 'specialUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_CHECKOUT]: 'defaultUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_BMI_STEP_V1]: 'defaultUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_BMI_STEP_V2]: 'defaultUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_LP_NEW_IMAGE_V1]: 'defaultUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_LP_NEW_IMAGE_V2]: 'defaultUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_EMAIL_CONSENT_STEP]: 'defaultUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_FLAT_BELLY]: 'specialUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_SOMATIC_PILATES]: 'specialUrl',
    [QUIZ_VARIANTS.PILATES_NOW]: 'specialUrl',
    [QUIZ_VARIANTS.PILATES_LEGAL_DISCLAIMER]: 'specialUrl',
    [QUIZ_VARIANTS.YOGA_MENOPAUSE_CHALLENGE]: 'specialUrl',
    [QUIZ_VARIANTS.NUTRITION_MONTHLY_GENERIC_US]: 'specialUrl',
    [QUIZ_VARIANTS.NUTRITION_MONTHLY_GENERIC_OTHERS]: 'compliantOthers',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_GENERIC_US]: 'specialUrl',
    [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_GENERIC_OTHERS]: 'compliantOthers',
    [QUIZ_VARIANTS.YOGA_28_DAY_CHALLENGE_GENERIC_US]: 'specialUrl',
    [QUIZ_VARIANTS.YOGA_28_DAY_CHALLENGE_GENERIC_OTHERS]: 'compliantOthers',
    [QUIZ_VARIANTS.NUTRITION_KETO_MEAL_WEEKLY_GENERIC_US]: 'specialUrl',
    [QUIZ_VARIANTS.WALKING_INDOOR]: 'specialUrl',
    [QUIZ_VARIANTS.WALKING_INDOOR_V1]: 'specialUrl',
    [QUIZ_VARIANTS.WALKING_TREADMILL]: 'specialUrl',
    [QUIZ_VARIANTS.YOGA_28_DAY_CHALLENGE_SENIOR_V1]: 'specialUrl',
    [QUIZ_VARIANTS.YOGA_28_DAY_CHALLENGE_SENIOR_V2]: 'specialUrl',
    [QUIZ_VARIANTS.NUTRITION_FASTING]: 'specialUrl',
  };

  const variantKey = variantMap[quizVariant] || 'defaultUrl';
  return baseUrls[type][variantKey];
};

export const getFetchUrl = ({ type, locale, isEuOrUk, quizVariant }) => {
  const baseUrl =
    isEuOrUk && type === 'privacy'
      ? baseUrls[type].europeAndUkUrl || baseUrls[type].defaultUrl
      : getBaseUrl(type, quizVariant);

  return locale !== 'en' ? `${baseUrl}-${locale}` : baseUrl;
};

export const fetchContent = async (url) => {
  try {
    const baseDomain = getBaseDomain(window.location.hostname);
    const baseUrl = `${window.location.protocol}//${baseDomain}/`;
    const normalizedUrl = new URL(url, baseUrl);

    const response = await fetch(normalizedUrl.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'text/plain',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.text();
    return data;
  } catch (error) {
    console.error(`Error fetching content ${url}:`, error);
    throw error;
  }
};

export const parseHTML = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const sectionContent = doc.querySelector('.container-terms');
  return sectionContent ? sectionContent.innerHTML : 'Content not found';
};
